import { ActionIcon, Box } from "@mantine/core";
import { IconArrowBarDown, IconArrowBarToUp } from "@tabler/icons-react";
import ActionButton from "../ActionButton";
import { toolIcon } from "./icons";
import classes from "./SharedItem.module.css";
import ToolUse from "./ToolUse";
import type { ItemViewProps } from "./types";

export const ICON_SIZE = 32;

export function FunctionCallItemView({
    item,
    opened,
    onOpen,
    onClose,
    actionButtons,
    containerClassName,
    showActions = true,
    containerRef,
}: ItemViewProps) {
    return (
        <Box className={`${classes.container} ${containerClassName ?? ""}`} ref={containerRef}>
            {showActions && (
                <ActionIcon.Group className={classes.icons}>
                    {item.context && (
                        <>
                            {!opened && (
                                <ActionButton
                                    onClick={onOpen}
                                    label="Show content"
                                    icon={<IconArrowBarDown stroke={1} />}
                                />
                            )}
                            {opened && (
                                <ActionButton
                                    onClick={onClose}
                                    label="Hide content"
                                    icon={<IconArrowBarToUp stroke={1} />}
                                />
                            )}
                        </>
                    )}
                    {actionButtons}
                </ActionIcon.Group>
            )}
            <Box>{toolIcon(item.toolName, ICON_SIZE)}</Box>
            <Box className={classes.content}>
                {opened ? (
                    <ToolUse item={{ toolName: item.toolName, toolArguments: item.toolArguments }} />
                ) : (
                    <Box>TOOL CALL</Box>
                )}
            </Box>
        </Box>
    );
}
